

<div class="page-wrapper">
<nz-page-header 
*ngIf="!isAuthorized"
[nzTitle]="customTitle" 

 class="custome-header"
 ></nz-page-header>

<ng-template #customTitle>
  <span class="catalog-title"> {{catalogName}}</span>
</ng-template>


<div   *ngIf="isLoading" class="loading-container">
  <nz-spin nzSimple nzSize="large"></nz-spin>
</div>



<div class="catalog-panel"  *ngIf="!isLoading">
  <div class="left-section">

    <img alt="image"
      [src]="catalogImageUrl  ? (catalogImageUrl| safeHtml:'url')  : '../../../assets/defaultCatalogImage.png'"
      class="catalog-image">


    <div class="text-content">
   
      <h3 *ngIf="catalogName">{{catalogName}}</h3>
      <p *ngIf="description">{{description}}</p>
    </div>
  </div>
  <div class="right-section">
    <img
      [src]="catalogBannerUrl  ? (catalogBannerUrl | safeHtml:'url')  :'../../../assets/defaultCatalogBanner.png'"
       alt="Catalog Banner" class="banner-image">
  </div>
</div>

<div class="main-container" *ngIf="!isLoading">
  <!-- Filter sidebar content here -->
  <div class="catalog-container">
    <!-- Search Bar -->
    <div class="search-bar">
      <nz-input-group [nzSuffix]="suffixIconSearch">
        <input [(ngModel)]="searchValue" nz-input class="search-input" [placeholder]="'Search by name or sku' | translate"
          (ngModelChange)="search()" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i class="fa-solid fa-magnifying-glass"></i>
      </ng-template>
    </div>
    <div class="product-grid" *ngIf="filteredCatalog">
      <nz-card nzHoverable *ngFor="let product of filteredCatalog"
      
      [routerLink]="['/product-catalog/product-details', catalogId, catalogCode, product.id,catalogName]">
      <!-- <img alt="product image" [src]="product.mainImage ? product.mainImage : '../../../assets/defaultProductCatalog.jpg' "
       class="product-image"> -->
   
       <img
  alt="product image"
  [src]="product.mainImage  ?(product.mainImage | safeHtml:'url'):'../../../assets/defaultProductCatalog.jpg'"
  class="product-image">

      <div class="product-info">
        <div>{{ product.name }}</div>
        <div>{{ product.sku }}</div>
      </div>
    
      <div class="product-price">
        <span *ngIf="product.price && productsCatalog.currency">
          <!-- {{ product.price }} {{productsCatalog.currency}} -->
      {{ product.price | priceFormat:productsCatalog.currency }}
        </span>
      </div>
    </nz-card>
    

    </div>

    <div class="pagination-container">
      <nz-pagination *ngIf="!isLoading" [(nzPageIndex)]="configTableParams.currentPage"
        [nzPageSize]="configTableParams.pageSize" [nzTotal]="productsCatalog.products.length"
        (nzPageIndexChange)="onPageChange($event)">
      </nz-pagination>

    </div>
  </div>
</div>

<footer class="custom-footer" *ngIf="!isAuthorized">
  <div class="catalog-title ">{{catalogName}}</div>
  <div class="footer-right">{{'All rights reserved' | translate}}</div>
</footer>
</div>